export const SAVE_CAMPAIGNS_DATA = "SAVE_CAMPAIGNS_DATA";
export const SAVE_SELECT_CAMPAIGN = "SAVE_SELECT_CAMPAIGN";
export const RESET_DATA="RESET_DATA"